module.exports = __webpack_public_path__ + "assets/img/arrow-cherry.136cd4e6.svg";